<div [toggleClass]="'!_hidden'"
     [toggleClassBy]="tabsContent">
    <ng-content></ng-content>
</div>